import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { Toaster } from 'react-hot-toast';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import throttle from 'lodash/throttle';
import { useAction } from 'hooks';
import App, { CookiesInfo, IntlHelmet, LanguageProvider, OfflineOverlay } from 'modules/App';
import Account from 'modules/Account';
import DataSources from 'modules/DataSources';
import { NotificationsSettingsModal } from 'modules/Notifications';
import * as actions from '../../actions';
import { useIsPinnedMenu } from '../../hooks';
import messages from '../../messages';
import styles from '../../components/MainLayout/MainLayout.pcss';
const MainLayout = ({ metaTitleMessage, metaDescriptionMessage, activeVisit, children })=>{
    const isPinnedMenu = useIsPinnedMenu(activeVisit);
    const isPrintMode = useSelector(App.selectors.printMode);
    const countrySettings = useSelector(Account.selectors.countrySettings);
    const devices = useSelector(App.selectors.devices);
    const dataSources = useSelector(DataSources.selectors.dataSources);
    const setMenuOpen = useAction(actions.setMenuOpen);
    const setSelectedMenuItem = useAction(actions.setSelectedMenuItem);
    const setWindowWidth = useAction(actions.setWindowWidth);
    const closeDropdown = useAction(App.actions.closeDropdown);
    const fetchDevices = useAction(App.actions.fetchDevices);
    const fetchCountrySettings = useAction(Account.actions.fetchCountrySettings);
    const fetchDataSources = useAction(DataSources.actions.fetchDataSources);
    const titleMessage = metaTitleMessage || messages.meta.title;
    const descriptionMessage = metaDescriptionMessage || messages.meta.description;
    const updateScreenWidth = (shouldSetBaseMenuOpen)=>{
        if (!process.env.BROWSER) {
            return;
        }
        setWindowWidth(window.innerWidth, shouldSetBaseMenuOpen === true);
    };
    const onUpdateScreenWidth = throttle((shouldSetBaseMenuOpen)=>updateScreenWidth(shouldSetBaseMenuOpen), 300);
    useEffect(()=>{
        if (!countrySettings) fetchCountrySettings();
        if (!devices.length) fetchDevices();
        if (!dataSources.length) fetchDataSources();
        window.addEventListener('resize', onUpdateScreenWidth);
        onUpdateScreenWidth(true);
        return ()=>{
            window.removeEventListener('resize', onUpdateScreenWidth);
        };
    }, []);
    useStyles(styles);
    const closeAll = ()=>{
        closeDropdown();
        if (!isPinnedMenu) {
            setMenuOpen(false);
        }
        setSelectedMenuItem(null);
    };
    const onKeyDown = (evt)=>{
        // If ESC
        if (evt.keyCode === 27) {
            closeAll();
        }
    };
    return /*#__PURE__*/ _jsx(LanguageProvider, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: cn({
                [styles.root]: !isPrintMode,
                [styles.print]: isPrintMode,
                print: isPrintMode
            }),
            onClick: closeAll,
            onKeyDown: onKeyDown,
            children: [
                /*#__PURE__*/ _jsx(IntlHelmet, {
                    titleMessage: titleMessage,
                    descriptionMessage: descriptionMessage
                }),
                /*#__PURE__*/ _jsx(CookiesInfo, {}),
                children,
                /*#__PURE__*/ _jsx(NotificationsSettingsModal, {}),
                /*#__PURE__*/ _jsx(OfflineOverlay, {}),
                process.env.BROWSER && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ReactTooltip, {
                            id: "globalTooltip",
                            place: "bottom",
                            type: "dark",
                            effect: "solid",
                            className: "tooltip"
                        }),
                        /*#__PURE__*/ _jsx(Toaster, {
                            position: "top-right"
                        })
                    ]
                })
            ]
        })
    });
};
export default MainLayout;
